import { AfterViewInit, Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, ParamMap,Router } from '@angular/router';
import { LeadTypeClass } from 'src/app/model/LeadType';
import { SharedService } from 'src/app/services/shared.service';
import { environment } from 'src/environments/environment';
import { getParamsType } from 'src/app/model/getParamsType';
import { GoogleAnalyticsService } from '../DataLayer/google-analytics-service.service';
@Component({
    selector: 'app-contact',
    templateUrl: './contact.component.html',
    styleUrls: ['./contact.component.scss'],
    standalone: false
})

export class ContactComponent implements OnInit,AfterViewInit {
  fName: boolean = false;
  lName: boolean = false;
  jTitle: boolean = false;
  wEmail: boolean = false;
  pNum: boolean = false;
  showAllErrors: boolean = false;
  submitted = false;
  leadInfo: any;
  loading: boolean = false;
  adobeDtmUrl: any;
  leadId: any;
  zipcodeSearchSubscriber: any;
  firstName: any;
  lastName: any;
  emailaddress1: any;
  mobilephone: any;
  entityId: any;
  jobtitle:any;
  loaderStyle: any = 370;
  scrollValue: any = 0;
  scrollStyle: any = '';
  action:any;
  nextBtnText:String="Next";
  clinicId:any;
  AriaTextSubmitBtn:any 

  
  constructor(private router: Router,protected $gaService: GoogleAnalyticsService,private route: ActivatedRoute,public leadTypeClass: LeadTypeClass,public sharedService: SharedService) { 

    // this
    // .$gaService
    // .eventEmitter("contact");
  }

  ngOnInit(): void { 

    this.sharedService.checkParentComponent();
    //this.loadAdobeDTM();
    window.top?.postMessage('rx-group-clinic-iframe-container', '*');
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.leadId = params.get('id');
      this.action=params.get('action');
      this.clinicId=params.get('gid');
      if(this.action=='CE'||this.action=='RE'){
        this.nextBtnText="Back";
      }
      if (this.leadId)
        this.getLead(this.leadId);
    })
    
    var device = this.$gaService.mobileOrLaptopdevice();
    if(device=="Mobile"){
      this.AriaTextSubmitBtn=this.nextBtnText=="Next" ? "Next button double tap to activate the ": "Back button double tap to activate the "
    }
    else{
      this.AriaTextSubmitBtn =this.nextBtnText;
    }
  // this.AriaTextSubmitBtn =device=="Mobile" && this.nextBtnText=="Next" ?"Next button double tap to activate the ":device=="Mobile" && this.nextBtnText=="Back" ?this.nextBtnText;

  }

  onContactFormSubmit(form: NgForm) {
    if (form.valid) {
      this.createLead(form.value);
      // this.router.navigateByUrl('/organisation');
    } else {
      this.showAllErrors = true;
      form.value.firstName = "" ? this.fName = false : this.fName = true;
      form.value.lastName = "" ? this.lName = false : this.lName = true;
      form.value.jobTitle = "" ? this.jTitle = false : this.jTitle = true;
      form.value.wEmail = "" ? this.wEmail = false : this.wEmail = true;
      form.value.pNum = "" ? this.pNum = false : this.pNum = true;
    }
  }


  ngAfterViewInit(): void {
   
    // this
    // .$gaService
    // .eventEmitter("contact");
  }


  // loadAdobeDTM() {
  //   if (environment.production) {
  //     this.adobeDtmUrl =
  //       'https://assets.adobedtm.com/launch-ENd8a7ca47a5e943c9915bbea04a4d1b05.min.js';
  //   } else {
  //     this.adobeDtmUrl =
  //       'https://assets.adobedtm.com/launch-EN7c6a70eddf864f739b21b4930b09faeb-development.min.js';
  //   }
  //   this.adobeDTM.loadJsScript(
  //     this.renderer,
  //     this.adobeDtmUrl,
  //     this.adobeDtmUrl
  //   );
  // }

  getLead(leadId: any) {
    const relativePath: string = 'groupclinic/getClinicLead';
    console.log("responseee1")
    const getParams: getParamsType = {
      entityName: "lead",
      entityId: leadId,
      columns: "emailaddress1,lastname,mobilephone,firstname,jobtitle"
    }
    this.loading = true;
    this.zipcodeSearchSubscriber = this.sharedService.postRequest(relativePath, getParams).subscribe(response => {
      this.leadInfo = JSON.parse(JSON.stringify(response));
      localStorage.setItem('leadInfo', JSON.stringify(this.leadInfo));
      console.log("responseee",response)
      if (response) {
        
        // this.leadTypeClass.contactInformationParams.firstname=response.firstname,
        // this.leadTypeClass.contactInformationParams.lastname=response.lastname,
        // this.leadTypeClass.contactInformationParams.emailaddress1=response.emailaddress1,
        // this.leadTypeClass.contactInformationParams.mobilephone=response.mobilephone
          this.firstName = response.firstname,
          this.lastName = response.lastname,
          //this.jobTitel = response.jobTitle
          this.emailaddress1 = response.emailaddress1,
          this.mobilephone =  response.mobilephone 
          this.jobtitle=response.jobtitle 
          
          // this.firstName != "" ? this.fName = false : this.fName = true;
          // this.lastName != "" ? this.lName = false : this.lName = true;
          // //form.value.jobTitle = "" ? this.jTitle = false : this.jTitle = true;
          // this.emailaddress1 != "" ? this.wEmail = false : this.wEmail = true;
          // this.mobilephone  != "" ? this.pNum = false : this.pNum = true;
       
      }
      
      this.loading = false;
    },
      errorResponse => {
        this.loading = false;
      })
  }


  createLead(formvalue : any) {
    this.loading = true;
    let createLeadUrl = 'groupclinic/createClinicLead';
    let UpdateLeadUrl = 'groupclinic/UpdateClinicLead'

    if (this.leadId) {
      this.entityId = this.leadId
    }
    let submitObj = JSON.parse(JSON.stringify(formvalue));
    submitObj["aci_leadtype"] = '805170000';
    submitObj["aci_iscreatedfromportal"] = 'true';
    console.log("submitObj",submitObj)
    Object.assign(this.leadTypeClass.contactInformationParams, formvalue);
    console.log("this.leadTypeClass.contactInformationParams",this.leadTypeClass.contactInformationParams);

    if(this.leadId)
    {
      console.log("update",submitObj,this.leadId)
      submitObj["entityId"]=this.leadId
      this.sharedService.postRequest(UpdateLeadUrl, submitObj).subscribe(res => {
       
        if(this.action=='RE'||this.action=='CE')
        {
          this.router.navigate(['/review-details', { id: this.leadId, action:this.action,gid:this.clinicId }])
        }
        else if(this.action == 'singleclinic')
        {
            this.router.navigate(['/organisation', { id:this.leadId,gid: this.clinicId, action: "singleclinic" }])
        }
        else if(this.action == 'noclinic')
        {
            this.router.navigate(['/organisation', { id:this.leadId,gid: this.clinicId, action: "noclinic" }])
        }
        else 
        {
          this.router.navigate(['/organisation', { id: this.leadId, leadType: "update" }])
        }
        
        this.loading = false;
      }, errorResponse => {
        this.loading = false;
       });
    }
    else{
      this.sharedService.postRequest(createLeadUrl, submitObj).subscribe(res => {
        this.router.navigate(['/organisation', { id: res.entityId, leadType: "create" }])
        this.loading = false;
        console.log("res",res)
      }, errorResponse => {
        this.loading = false;
       });
  
    }
  }

}

